/* React */
import { useEffect } from 'react'

/* Redux */
import { useDispatch } from 'src/redux/hooks'

/* Functions */
import isTouchDevice from 'src/functions/isTouchDevice'
import { getStoredCookieConsent } from 'src/functions/cookieConsent'

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */

const GlobalDidMountFunctions = () => {
  const dispatch = useDispatch()

  useEffect(() => {

    // Touch-Geräte erkennen
    dispatch({ type: 'isTouchDeviceToggle', payload: isTouchDevice() })

    const cookieConsent = getStoredCookieConsent()

    if (!cookieConsent) {
      dispatch({ type: 'showCookieBanner' })
      return
    }

    dispatch({ type: 'setCookieConsent', payload: cookieConsent })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return null
}

export default GlobalDidMountFunctions

/* +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ */
